import api from './api';

/**
 * Notification Service
 * Handles user notifications and preferences
 */
export const notificationService = {
  // ==================== Notifications ====================
  
  /**
   * Get all notifications
   */
  async getNotifications(params) {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/notifications?${queryString}`);
  },

  /**
   * Get unread notifications
   */
  async getUnreadNotifications() {
    return api.get('/notifications/unread');
  },

  /**
   * Get notification count
   */
  async getNotificationCount() {
    return api.get('/notifications/count');
  },

  /**
   * Mark notification as read
   */
  async markAsRead(notificationId) {
    return api.put(`/notifications/${notificationId}/read`);
  },

  /**
   * Mark all as read
   */
  async markAllAsRead() {
    return api.put('/notifications/mark-all-read');
  },

  /**
   * Delete notification
   */
  async deleteNotification(notificationId) {
    return api.delete(`/notifications/${notificationId}`);
  },

  /**
   * Clear all notifications
   */
  async clearAll() {
    return api.delete('/notifications/clear-all');
  },

  // ==================== Notification Preferences ====================
  
  /**
   * Get notification preferences
   */
  async getPreferences() {
    return api.get('/notifications/preferences');
  },

  /**
   * Update notification preferences
   */
  async updatePreferences(preferences) {
    return api.put('/notifications/preferences', preferences);
  },

  /**
   * Get notification types
   */
  async getNotificationTypes() {
    return api.get('/notifications/types');
  },

  // ==================== Notification Settings ====================
  
  /**
   * Enable notifications for type
   */
  async enableNotificationType(type) {
    return api.post(`/notifications/types/${type}/enable`);
  },

  /**
   * Disable notifications for type
   */
  async disableNotificationType(type) {
    return api.post(`/notifications/types/${type}/disable`);
  },

  /**
   * Test notification
   */
  async testNotification(type) {
    return api.post('/notifications/test', { type });
  },

  // ==================== Email ====================

  /**
   * Send email invitation
   */
  async sendEmail(recipients, subject, msgBody, sender,attachment=null) {
    const recipientsArr = recipients.split(',').map(r => r.trim()).filter(Boolean);
    return api.post(`/email/sendMail`, {
      recipients: recipientsArr,
      msgBody,
      subject,
      attachment,
      sender,
    });
  },
};

export default notificationService;
